module.exports = __webpack_public_path__ + "static/media/20210411_160030_558_IMG_0506.dfec84a0.jpg";